import type { AuditEntityResponse, AuditEntityType, DataSourcesView, SystemStatusView } from '../../shared/types/index.js';
import { request } from './client.js';

export function fetchDataSources(): Promise<DataSourcesView> {
  return request<DataSourcesView>('/datasources');
}

export function fetchSystemStatus(): Promise<SystemStatusView> {
  return request<SystemStatusView>('/system-status');
}

/** Upstream task steps for an entity, e.g. `('PROFILE', suspect.auditId)`. */
export function fetchAuditLogById(type: AuditEntityType, id: string): Promise<AuditEntityResponse> {
  return request<AuditEntityResponse>('/audit/entity', { query: { type, id } });
}
